var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Input, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { useDebouncedCallback } from '../Debounce/DebounceCallback';
const startAdornment = (React.createElement(InputAdornment, { position: 'start' },
    React.createElement(SearchIcon, null)));
const DEFAULT_DEBOUNCE = 500;
export const DebounceSearchInput = (props) => {
    const { onSearchTermChanged, debounceDelay = DEFAULT_DEBOUNCE } = props, rest = __rest(props, ["onSearchTermChanged", "debounceDelay"]);
    const handleDebouncedSearch = useDebouncedCallback((term) => {
        onSearchTermChanged(term);
    }, debounceDelay);
    const onInputChange = ({ target: { value } }) => {
        handleDebouncedSearch(value);
    };
    return (React.createElement(Input, Object.assign({}, rest, { type: 'search', onChange: onInputChange, startAdornment: startAdornment })));
};
//# sourceMappingURL=DebouncedSearchInput.js.map